<template>
  <form class="ui-form" :class="{ 'uk-form-stacked': labelPosition === 'top' }">
    <slot></slot>
  </form>
</template>

<script>
import assign from 'lodash/assign'
import Promise from 'es6-promise'

export default {
  name: 'UiForm',

  provide() {
    return {
      uiForm: this,
    }
  },

  props: {
    labelPosition: {
      type: String,
      default: 'top',
    },

    labelColumns: {
      type: Number,
      default: 4,
    },

    inputColumns: {
      type: Number,
      default: 8,
    },

    model: Object,
    rules: Object,
  },

  data() {
    return {
      fields: [],
    }
  },

  methods: {
    focusOnFirstError() {
      this.$nextTick(() => {
        const containerEl = this.$el.querySelector('.ui-form-item.is-error')
        if (!containerEl) {
          return
        }

        containerEl.scrollIntoView(true)
        window.scrollBy(0, -200)

        const scrolledY = window.scrollY
        if (scrolledY) {
          window.scroll(0, scrolledY - 40)
        }

        const inputEl = containerEl.querySelector([
          '.ui-input__inner',
          '.ui-textarea__inner',
          '.ui-select__inner',
          '.form-check-input',
        ].join(', '))
        if (inputEl) {
          inputEl.focus()
        }
      })
    },

    validate() {
      return new Promise((resolve, reject) => {
        if (!this.model) {
          // eslint-disable-next-line no-console
          console.warn('[Form] model prop is required for validation')
          resolve(true)
          return
        }

        let valid = true
        let count = 0

        if (this.fields.length === 0) {
          resolve(true)
        }

        let invalidFields = {}
        this.fields.forEach((field) => {
          field.validate((message) => {
            if (message) {
              valid = false
            }

            invalidFields = assign({}, invalidFields, field)

            // eslint-disable-next-line no-plusplus
            if (++count === this.fields.length) {
              if (valid) {
                resolve(valid)
              } else {
                reject(valid, invalidFields)
              }
            }
          })
        })
      })
    },
  },

  created() {
    this.$on('ui.form.addField', (field) => {
      if (field) {
        this.fields.push(field)
      }
    })

    this.$on('ui.form.removeField', (field) => {
      if (field.prop) {
        this.fields.splice(this.fields.indexOf(field), 1)
      }
    })
  },
}
</script>
